import { z } from 'zod';
import { ROLES } from '../constants.js';
export const phoneSchema = z
    .string()
    .trim()
    .regex(/^\+?[0-9 ()\-]{7,20}$/, 'Неверный формат телефона')
    .transform((v) => v.replace(/[^\d+]/g, ''));
const birthMonthSchema = z.number().int().min(1).max(12);
const birthDaySchema = z.number().int().min(1).max(31);
/** Day-of-year birthday — month/day only, no year. */
export const birthMonthDaySchema = z
    .object({ birthDay: birthDaySchema, birthMonth: birthMonthSchema })
    .refine(({ birthDay, birthMonth }) => isValidMonthDay(birthMonth, birthDay), 'Некорректная дата');
/** Returns true if (month, day) is a real calendar date, accepting Feb 29
 *  (we don't track years, so leap-year edge cases never apply). */
export function isValidMonthDay(month, day) {
    const lastDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1];
    return Number.isInteger(month) && Number.isInteger(day) && day >= 1 && lastDay !== undefined && day <= lastDay;
}
export const userDtoSchema = z.object({
    id: z.string(),
    tgId: z.string(),
    username: z.string().nullable(),
    firstName: z.string(),
    lastName: z.string().nullable(),
    photoUrl: z.string().url().nullable(),
    phone: z.string().nullable(),
    birthDay: z.number().int().nullable(),
    birthMonth: z.number().int().nullable(),
    role: z.enum(ROLES),
    createdAt: z.string(),
});
/** Day+month update — both values are sent together (or both nulled to clear). */
export const updateMeSchema = z.object({
    // Empty string is an explicit "clear my phone" signal (mapped to null server-side);
    // a non-empty value must still pass phoneSchema.
    phone: phoneSchema.or(z.literal('')).optional(),
    birthDay: birthDaySchema.nullable().optional(),
    birthMonth: birthMonthSchema.nullable().optional(),
});
